import React from "react";
import "./AppFooter.css";

const AppFooter: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="app-footer mt-4 bg-primary">
      <div className="container text-center text-white" style={{opacity:0.5}}>
        © {year} Hatchway. All rights reserved.
      </div>
    </footer>
  );
};

export default AppFooter;
